import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import SpreadCard from './spread-card';

class Component extends BaseComponent {
    componentDidMount() {
        if (this.props.positions.length && this.props.houses) {
            this.props.orientPositions();
        }
    }

    render({ positions }) {
        return (
            <spread-partial>
                {positions.map((position, i) => this.renderSpreadCard(position, i))}
            </spread-partial>
        );
    }

    renderSpreadCard = (position, i) => {
        let attrs = {
            position: position,
            card_id: this.props.picked_cards[position.card_index],
            card_index: position.card_index,
            orientation: position.orientation,
            view: this.props.view,
        };

        if (this.props.houses) {
            attrs.house = this.props.houses[i];
        }

        return (
            <SpreadCard {...attrs} />
        );
    }
}

const mapStateToProps = (state) => ({
    picked_cards: state['tarot-reading'].cards,
});

const mapDispatchToProps = (dispatch) => ({
    orientPositions: () => dispatch({ type: 'tarot-reading:orient' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
